<template>
  <FulfillmentScreen
    :order="order"
    :title="`Packing Order #${order.id}`"
    :back-route="route('fulfillment.index')"
  >
    <template #table>
      <OrderLineItemsTable :order="order" />
    </template>

    <template #receipt>
      <Receipt :order="order">
        <template #controls>
          <ReceiptControls
            :order="order"
            :canComplete="fulfillmentService.state.canComplete"
            @complete="fulfillmentService.completeOrder()"
            @complete-and-notify="fulfillmentService.completeOrder({ notify: true })"
            @finalize-cancel="fulfillmentService.finalizeCancelOrder()"
            @finalize-cancel-and-notify="fulfillmentService.finalizeCancelOrder({ notify: true })"
          />
        </template>
      </Receipt>
    </template>

    <template #modals>
      <MediumModal
        :is-open="lockService.lockedModal.state.isOpen"
        :show-close-button="false"
      >
        <template #header>Order Locked</template>
        <div class="flex flex-col gap-4">
          <p>{{ lockService.lockedModal.state.message }}</p>
          <div class="flex gap-x-2 justify-end">
            <button
              @click="router.visit(route('fulfillment.index'))"
              class="btn btn-secondary-outline text-blue-600"
            >
              Cancel
            </button>
            <button
              @click="lockService.lockedModal.override"
              class="btn btn-primary"
            >
              Take Over
            </button>
          </div>
        </div>
      </MediumModal>
    </template>
  </FulfillmentScreen>
</template>

<script setup>
import { provide } from 'vue'
import Receipt from '@/Pages/Fulfillment/Receipt.vue'
import OrderLineItemsTable from '@/Components/DataGrid/Tables/OrderLineItems'
import MediumModal from '@/Components/Modals/MediumModal'
import { useFulfillmentService, MODES } from '@/Composables/Fulfillment/fulfillment-service'
import { FULFILLMENT_SERVICE } from '@/Composables/Fulfillment/constants'
import { router } from '@inertiajs/vue3'
import { useLockService } from '@/Pages/Fulfillment/lock-service'
import ReceiptControls from '@/Pages/Fulfillment/ReceiptControls.vue'
import FulfillmentScreen from '@/Screens/FulfillmentScreen.vue'

const props = defineProps({
  order: {
    type: Object,
    required: true
  }
})

const fulfillmentService = useFulfillmentService({ order: props.order, mode: MODES.PACKING })
provide(FULFILLMENT_SERVICE, fulfillmentService)

const lockService = useLockService({
  order: props.order,
  fulfillmentService
})
</script>
